import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import RootReducer from "./reducers/RootReducer";

//codefire
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

//codefire
const persistConfig = {
  key: "reactone",
  storage: storage,
};

const middlewares = [thunk];
const { logger } = require(`redux-logger`);

// middlewares.push(logger);
let devtools = (x) => x;

// if (
//   process.env.NODE_ENV !== "production" &&
//   process.browser &&
//   window.__REDUX_DEVTOOLS_EXTENSION__
// ) {
//   devtools = window.__REDUX_DEVTOOLS_EXTENSION__();
// }

export const Store = createStore(
  RootReducer,
  // initialState,
  compose(applyMiddleware(...middlewares), devtools)
);

//codefire
const persistedReducer = persistReducer(persistConfig, RootReducer);

export default () => {
  let store = createStore(
    persistedReducer,
    compose(applyMiddleware(...middlewares), devtools)
  );
  let persistor = persistStore(store);
  return { store, persistor, Store };
};
